import { styled } from '@mui/material';

export const StyledFilterInput = styled('div')<{ hasError: boolean }>(({ hasError, theme }) => ({
  border: '1px solid',
  borderColor: `${hasError ? theme?.palette.error.main : theme?.palette.secondary.main} !important`,
  borderRadius: '4px',
  paddingY: theme.spacing(1),
  backgroundColor: 'transparent',
  width: '100%',
}));
